import { Color, ShaderMaterial, Vector3 } from 'three'
import GradinetsShader from '../shaders/GradientsShader'

// eslint-disable-next-line import/no-unused-modules
export default function Gradients({ fsQuad, renderer }) {
    const uniforms = GradinetsShader.getUniforms()

    const material = new ShaderMaterial({
        vertexShader: GradinetsShader.vertexShader,
        fragmentShader: GradinetsShader.fragmentShader,
        uniforms,
        transparent: true,
    })

    this.setScreenSize = (newSize) => {
        uniforms.u_resolution.value = newSize
    }

    this.setInnerColor = (color) => {
        const { r, g, b } = new Color(color)
        uniforms.u_inner_color.value = new Vector3(r, g, b)
    }

    this.setInnerColor('#020612')

    this.setOuterColor = (color) => {
        const { r, g, b } = new Color(color)
        uniforms.u_outer_color.value = new Vector3(r, g, b)
    }

    this.setOuterColor('#020612')

    this.setInnerWidth = (width) => {
        uniforms.u_inner_width.value = width
    }

    this.setInnerWidth(2)

    this.setOuterWidth = (width) => {
        uniforms.u_outer_width.value = width
    }

    this.setOuterWidth(2)

    this.render = (phase, { coverage = 0.8, curvature = 0.12 } = {}) => {
        const { x, y } = uniforms.u_resolution.value

        uniforms.u_offset.value = phase * coverage * y

        uniforms.u_height.value = phase * curvature * x * 0.5

        uniforms.u_phase.value = phase

        fsQuad.material = material

        fsQuad.render(renderer)
    }
}
